import { combineReducers } from "redux";
import commonReducers from "./commonReducers";

export const rootReducer = combineReducers({
  ...commonReducers,
});

export type RootState = ReturnType<typeof rootReducer>;
